import Agora, { AREAS, SDK_CODEC, SDK_MODE } from 'agora-rtc-sdk-ng';

export const AGORA_CLIENT_CALL_SETTINGS: {
  mode: SDK_MODE;
  codec: SDK_CODEC;
  areaCode: AREAS[];
} = {
  mode: 'live',
  codec: 'vp8',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  areaCode: [Agora.AREAS.GLOBAL],
};
